<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="sales"
      :filtersValue="filtersValue"
      :sort="sort"
      :date="date"
      :externalFilters="pageSize"
    />

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Продажи</h1>
        <select v-model="pageSize" class="custom-select mr-2" style="max-width: 6em;">
          <option v-for="size in pageSizes" :value="size">{{size}}</option>
        </select>
        <el-date-picker
          class="mr-2"
          v-model="date"
          type="datetimerange"
          :clearable="false"
          value-format="yyyy-MM-ddTHH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          range-separator="–"
          :picker-options="pickerOptions"
          size="small"
        />
        <btn-filters
          :data="data"
          endpoint="sales"
          v-model="filtersValue"
        />
      </div>
    </div>

    <data-table-full-height
      v-if="data && data.data"
      :data="data.data"
      @sort-change="sortChange"
      :default-sort = "{prop: 'sum', order: 'descending'}"
      show-summary
    >
      <table-column-serial-number :fixed="true"/>
      <table-column-string prop="address" label="Адрес установки" :show-overflow-tooltip="true" min-width="275" tableColumnType="string"/>

      <table-column-number align="right" sortable="custom" prop="count" label="Всего продаж" min-width="122" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="cash" label="За наличные" min-width="120" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="cashless" label="По безналу" min-width="120" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="free" label="Бесплатных" min-width="115" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="test" label="Тестовых" min-width="110" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="token" label="За жетоны" min-width="110" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum_cash" label="Сумма налич" min-width="118" currencySymbol="₽" tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum_cashless" label="Сумма безнал" min-width="124" currencySymbol="₽" tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum" label="Сумма общая" min-width="120" currencySymbol="₽" tableColumnType="number"/>

      <table-column-date prop="last_sale_at" label="Последняя продажа" align="right"/>
    </data-table-full-height>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    metaInfo: {title: 'Продажи'},
    data () {
      return {
        filtersValue: null,
        data: {},
        sort: null,
        date: [
          moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
          moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
        ],
        pickerOptions: {
          firstDayOfWeek: 1,
        },
        pageSizes: [100, 250, 500, 1000, 2500, 5000, 10000],
        pageSize: 100,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/sales.vue